import React from 'react';
import {ClipLoader, BounceLoader, PropagateLoader} from 'react-spinners';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  render() {

    let spinner =
      <div className='sweet-loading'>
        <BounceLoader
          sizeUnit={"px"}
          size={this.props.size ? this.props.size : 50}
          color={this.props.color ? this.props.color : '#0085ca'}
          loading={this.state.loading}
        />
      </div>;

    if (this.props.type === 0) {
      spinner =
        <div className={"wrap-sweet-loading"}>
          <div className='sweet-loading'>
            <PropagateLoader
              sizeUnit={"px"}
              size={this.props.size ? this.props.size : 50}
              color={this.props.color ? this.props.color : '#0085ca'}
              loading={this.state.loading}
            />
          </div>
        </div>
    }

    if (this.props.type === 1) {
      spinner = this.props.isColor ?
        <div className='sweet-loading'>
          <BounceLoader
            sizeUnit={"px"}
            size={this.props.size ? this.props.size : 50}
            color={this.props.color ? this.props.color : '#0085ca'}
            loading={this.state.loading}
          />
        </div>
        :null
    }

    return spinner
  }
}

export default App;
